module.exports = __webpack_public_path__ + "static/media/WealthBanner.b586007c.png";